import React, { useState, useEffect } from 'react';

const FIELDS = [
  { key: 'mbps_rd',     label: 'Leitura (MB/s)',       group: 'mbps' },
  { key: 'mbps_wr',     label: 'Escrita (MB/s)',        group: 'mbps' },
  { key: 'iops_rd',     label: 'Leitura (IOPS)',        group: 'iops' },
  { key: 'iops_wr',     label: 'Escrita (IOPS)',        group: 'iops' },
  { key: 'mbps_rd_max', label: 'Leitura burst (MB/s)',  group: 'mbps_burst' },
  { key: 'mbps_wr_max', label: 'Escrita burst (MB/s)',  group: 'mbps_burst' },
  { key: 'iops_rd_max', label: 'Leitura burst (IOPS)',  group: 'iops_burst' },
  { key: 'iops_wr_max', label: 'Escrita burst (IOPS)',  group: 'iops_burst' },
];

function emptyThrottle() {
  const t = {};
  for (const f of FIELDS) t[f.key] = 0;
  return t;
}

function VMDiskThrottleModal({ disks, saving, msg, onClose, onSave, inline = false }) {
  const wrap = (node) => (inline ? node : <div className="confirm-overlay" onClick={onClose}>{node}</div>);
  const panelClass = (extra = '') => `confirm-modal${extra}${inline ? ' inline-panel' : ''}`;
  const [selectedDisk, setSelectedDisk] = useState(disks?.[0]?.disk || '');
  const [values, setValues] = useState(() => {
    const init = {};
    for (const d of (disks || [])) init[d.disk] = { ...emptyThrottle(), ...d.throttle };
    return init;
  });

  useEffect(() => {
    if (disks?.length && !selectedDisk) setSelectedDisk(disks[0].disk);
  }, [disks, selectedDisk]);

  const current = values[selectedDisk] || emptyThrottle();

  function handleChange(key, raw) {
    const v = raw === '' ? 0 : Math.max(0, parseInt(raw, 10) || 0);
    setValues(prev => ({ ...prev, [selectedDisk]: { ...prev[selectedDisk], [key]: v } }));
  }

  function handleClear() {
    setValues(prev => ({ ...prev, [selectedDisk]: emptyThrottle() }));
  }

  if (!disks || disks.length === 0) {
    return wrap(
        <div className={panelClass()} onClick={e => e.stopPropagation()}>
          <h3 className="confirm-title">💾 Throttle de Disco</h3>
          <p style={{ color: 'var(--text-2)', margin: '16px 0' }}>Nenhum disco encontrado nesta VM.</p>
          <div className="confirm-actions">
            <button className="confirm-btn cancel" onClick={onClose}>Fechar</button>
          </div>
        </div>
    );
  }

  return wrap(
      <div className={panelClass(' resize-modal')} style={{ minWidth: inline ? 0 : 480 }} onClick={e => e.stopPropagation()}>
        <h3 className="confirm-title">💾 Throttle de Disco</h3>

        {disks.length > 1 && (
          <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
            {disks.map(d => (
              <button
                key={d.disk}
                className={`resize-preset-btn${selectedDisk === d.disk ? ' active' : ''}`}
                onClick={() => setSelectedDisk(d.disk)}
                disabled={saving}
              >
                {d.disk}
              </button>
            ))}
          </div>
        )}

        <p style={{ fontSize: 12, color: 'var(--text-2)', marginBottom: 12 }}>
          Disco: <strong>{selectedDisk}</strong> — 0 = sem limite
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 20px', marginBottom: 16 }}>
          {FIELDS.map(f => (
            <div key={f.key} className="resize-field" style={{ margin: 0 }}>
              <label className="resize-label" style={{ fontSize: 12 }}>{f.label}</label>
              <input
                type="number"
                className="resize-input"
                value={current[f.key] === 0 ? '' : current[f.key]}
                placeholder="0 (ilimitado)"
                onChange={e => handleChange(f.key, e.target.value)}
                min={0}
                disabled={saving}
                style={{ fontSize: 13 }}
              />
            </div>
          ))}
        </div>

        {msg && (
          <div className={`resize-msg ${msg.type}`}>{msg.text}</div>
        )}

        <div className="confirm-actions">
          <button className="confirm-btn cancel" onClick={onClose}>Fechar</button>
          <button
            className="confirm-btn cancel"
            onClick={handleClear}
            disabled={saving}
            style={{ marginRight: 'auto' }}
          >
            Limpar limites
          </button>
          <button
            className="confirm-btn confirm action-btn resize-confirm"
            onClick={() => onSave(selectedDisk, current)}
            disabled={saving}
          >
            {saving ? '⏳ Salvando...' : 'Aplicar'}
          </button>
        </div>
      </div>
  );
}

export default VMDiskThrottleModal;
